import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing, palette, typography }) => ({
  likeIconContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& span': {
      [breakpoints.up('md')]: {
        marginTop: '-4px'
      },
      fontSize: typography.body.s.fontSize,
      fontFamily: 'Red Hat Display'
    },
    [breakpoints.down('lg')]: {
      flexDirection: 'row'
    }
  },
  circularProgressContainer: {
    padding: spacing(2)
  },
  thankYouContainer: {
    background: palette.primary.main,
    color: palette.common.white,
    borderRadius: '50%',
    height: 50,
    width: 50,
    fontSize: typography.body.xs.fontSize,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    '& span': {
      textAlign: 'center'
    }
  }
}))
